<div class="modal-main create-user" [formGroup]="formGroup">
  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </ng-template>

  <ng-container *ngIf="!commonAccessControl">

    <app-verify-email
    class="d-none"
    [class.d-block]="stepper === 0"
    formGroupName="Email"
    [dialogRef]="dialogRef"
    [(stepper)]="stepper"
    [(skipStepUserType)]="skipStepUserType"
    [(skipStepBuilding)]="skipStepBuilding"
    (currentUserEmitter)="currentUserEmitter($event)"
  >
    <span backButton>
      <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
    </span>
  </app-verify-email>
  <ng-container *ngIf="stepper === 1">
    <app-user-details
      class="d-none"
      [class.d-block]="stepper === 1"
      formGroupName="userDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (currentUserEmitter)="currentUserEmitter($event)"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-details>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-user-type
      [flowType]="CONSTANTS.CREATE_USER"
      formGroupName="userTypes"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-type>
  </ng-container>


  <ng-container *ngIf="stepper === 3">
    <app-access-time
      formGroupName="accessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-access-time>
  </ng-container>

  <ng-container *ngIf="stepper >= 3">
    <app-access-detail-email
    [class.d-block]="stepper === 4"
    class="d-none"
      formGroupName="accessEmail"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (submitToParent)="submitToParent()"
      [errorMessage]="errorMessage"
      [selectedUnitAccessPoint]="selectedUnitAccessPoint"
      [skipStepBuilding]="skipStepBuilding"
      [flowType]="CONSTANTS.CREATE_USER"
      [(userGroup)]="userGroup"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-access-detail-email>
  </ng-container>

  <ng-container *ngIf="stepper >= 4">
    <app-completed
      [class.d-block]="stepper === 5"
      class="d-none"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (formReset)="formReset()"
    >
    </app-completed>
  </ng-container>
  <ng-container *ngIf="stepper === 8">
    <app-selected-units-accesspoints
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [selectedUnitAccessPoint]="selectedUnitAccessPoint"
      [(userGroup)]="userGroup"
      [sharedData]="sharedData"
      [flowType]="CONSTANTS.CREATE_USER"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-selected-units-accesspoints>
  </ng-container>

  </ng-container>


  <ng-container *ngIf="commonAccessControl">

    <app-verify-email
    class="d-none"
    [class.d-block]="stepper === 0"
    formGroupName="Email"
    [dialogRef]="dialogRef"
    [(stepper)]="stepper"
    [(skipStepUserType)]="skipStepUserType"
    [(skipStepBuilding)]="skipStepBuilding"
    (currentUserEmitter)="currentUserEmitter($event)"
  >
    <span backButton>
      <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
    </span>
  </app-verify-email>
  <ng-container *ngIf="stepper === 1">
    <app-user-details
      class="d-none"
      [class.d-block]="stepper === 1"
      formGroupName="userDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (currentUserEmitter)="currentUserEmitter($event)"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-details>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-user-type
      [flowType]="CONSTANTS.CREATE_USER"
      formGroupName="userTypes"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-type>
  </ng-container>

  <ng-container *ngIf="stepper === 3">
    <app-user-group
      [(userStepper)]="stepper"
      [(userGroup)]="userGroup"
      [(selectedGroup)]="selectedGroup"
      [skipStepUserType]="skipStepUserType"
      [alreadySelectedGroups]="alreadySelectedGroups"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-group>
  </ng-container>

  <ng-container *ngIf="stepper === 4">
    <app-access-time
      formGroupName="accessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-access-time>
  </ng-container>

  <ng-container *ngIf="stepper === 5">
    <app-access-detail-email
      formGroupName="accessEmail"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (submitToParent)="submitToParent()"
      [errorMessage]="errorMessage"
      [selectedUnitAccessPoint]="selectedUnitAccessPoint"
      [skipStepBuilding]="skipStepBuilding"
      [flowType]="CONSTANTS.CREATE_USER"
      [(userGroup)]="userGroup"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-access-detail-email>
  </ng-container>

  <ng-container *ngIf="stepper >= 5">
    <app-completed
      [class.d-block]="stepper === 6"
      class="d-none"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (formReset)="formReset()"
    >
    </app-completed>
  </ng-container>
  <ng-container *ngIf="stepper === 8">
    <app-selected-units-accesspoints
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [selectedUnitAccessPoint]="selectedUnitAccessPoint"
      [sharedData]="sharedData"
      [(userGroup)]="userGroup"
      [flowType]="CONSTANTS.CREATE_USER"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-selected-units-accesspoints>
  </ng-container>

  </ng-container>
</div>
